export enum PatientGender {
    UNKN = 0,
    M = 1,
    F = 2,
    I = 3
}